mutation DeleteAudienceMember($audienceMemberId: ID!) {
    audienceMemberDelete(input: {audienceMemberId: $audienceMemberId}) {
        audienceMember {
            id
            deletedTime
        }
    }
}
